export const MAX_CONTENT_WIDTH = 1280;
export const MAX_CONTENT_HEIGHT = 765;
export const PANEL_CHROME_HEIGHT = 40;
export const DEFAULT_PANEL_WIDTH = 480;

export const PANEL_ASPECT_RATIO = MAX_CONTENT_WIDTH / MAX_CONTENT_HEIGHT;

export const DEFAULT_PANEL_HEIGHT = Math.round(DEFAULT_PANEL_WIDTH / PANEL_ASPECT_RATIO) + PANEL_CHROME_HEIGHT;

export const MIN_PANEL_WIDTH = DEFAULT_PANEL_WIDTH;
export const MIN_PANEL_HEIGHT = Math.round(MIN_PANEL_WIDTH / PANEL_ASPECT_RATIO) + PANEL_CHROME_HEIGHT;
export const MIN_CONTENT_HEIGHT = MIN_PANEL_HEIGHT - PANEL_CHROME_HEIGHT;

export const MAX_PANEL_WIDTH = MAX_CONTENT_WIDTH;
export const DEFAULT_HUD_POSITION = { x: 80, y: 16 };

export const HUD_DEFAULT_PANEL_SIZE = { width: 640, height: Math.round(640 / PANEL_ASPECT_RATIO) + PANEL_CHROME_HEIGHT };
export const HUD_START_OFFSET = { x: 80, y: 16 };
export const HUD_PANEL_GAP = 16;

export function getDefaultPanelSize(entry) {
  const width = Number(entry?.defaultSize?.width || entry?.size?.width || DEFAULT_PANEL_WIDTH);
  const height = Number(entry?.defaultSize?.height || entry?.size?.height || DEFAULT_PANEL_HEIGHT);
  return {
    width: Number.isFinite(width) ? width : DEFAULT_PANEL_WIDTH,
    height: Number.isFinite(height) ? height : DEFAULT_PANEL_HEIGHT
  };
}

export const CAMERA_PANEL_COMMAND_EVENT = 'fiber:camera-panels';
